import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledGoodNews = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  Title: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  Card: styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;

    border-radius: 24px;
    background: ${Color.GRAY_LIGHTEST};
  `,
  Cover: styled.img`
    flex-shrink: 0;

    width: 116px;
    aspect-ratio: 504/608;
    display: block;
  `,
  Description: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_BASE};

    padding: 16px;
  `,
}
